export const ProjectResponseStatus = Object.freeze({
    PENDING: "pending",
    ACCEPTED: "selected",
    REJECTED: "rejected",
    CANCELLED: "cancelled"
});
